export default function FeaturesPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900">Fonctionnalités</h1>
      <p className="mt-4 text-gray-600">
        Découvrez les fonctionnalités de Free QR Code : QR statiques et dynamiques, personnalisation, statistiques détaillées et clés API.
      </p>
    </div>
  );
}
